import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../axiosInstance";
import moment from "moment";
import { Link } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import GetProfile from "../../Api/Speakers/Profile/GetProfile";

const Events = () => {
  const { t, i18n } = useTranslation();
  const languageDirection = i18n.language === "ar" ? "rtl" : "ltr";
  const { user, userId } = useAuth();
  toast.dismiss();
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [profileImage, setProfileImage] = useState("");
  const [profile, setProfile] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [events, setEvents] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [activeFilter, setActiveFilter] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  // const isLoggedIn = !!localStorage.getItem("token");
  const [userRole, setUserRole] = useState(null);
  useEffect(() => {
    const handleLogin = () => {
      const token = localStorage.getItem("token");
      setIsLoggedIn(!!token);

      if (token) {
        GetProfile.get()
          .then((response) => {
            setUserRole(response.userRole);
            setProfile(response);
            setUserName(
              i18n.language === "ar"
                ? response.arabicFullName
                : response.englishFullName
            );
            setProfileImage(response.profileImage || "");
          })
          .catch((error) => {
            console.error("خطأ في جلب بيانات المستخدم:", error);
          });
      }
    };

    handleLogin();

    window.addEventListener("user-logged-in", handleLogin);

    return () => {
      window.removeEventListener("user-logged-in", handleLogin);
    };
  }, []);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await axiosInstance.get("/api/v1/users/events");
        const data = response.data?.items || [];
        setEvents(data);
        setFilteredEvents(data);
      } catch (error) {
        console.error("حدث خطأ أثناء جلب الفعاليات", error);
      }
    };

    fetchEvents();
  }, []);

  useEffect(() => {
    let filtered = [...events];

    if (activeFilter === "upcoming") {
      filtered = filtered.filter((event) =>
        moment(event.eventOn).isAfter(moment())
      );
    } else if (activeFilter === "past") {
      filtered = filtered.filter((event) =>
        moment(event.eventOn).isBefore(moment())
      );
    } else if (activeFilter === "online") {
      filtered = filtered.filter((event) => event.isOnline);
    } else if (activeFilter === "in-person") {
      filtered = filtered.filter((event) => !event.isOnline);
    }

    if (searchQuery.trim() !== "") {
      filtered = filtered.filter((event) => {
        const name = event.arabicName || event.englishName || "";
        return name.toLowerCase().includes(searchQuery.toLowerCase());
      });
    }

    setFilteredEvents(filtered);
  }, [activeFilter, searchQuery, events]);

  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
  };

  // دالة طلب الانضمام
  const handleJoinRequest = async (eventId) => {
    if (!isLoggedIn) {
      navigate("/login");
      return;
    }

    const speakerId = userId;
    if (!speakerId) {
      toast.error(t("joinRequest.notSpeaker"));
      return;
    }

    try {
      const invitationMessage = t("joinRequest.invitationMessage");

      console.log("إرسال الطلب:", { speakerId, invitationMessage });

      await axiosInstance.post(
        `/api/v1/speakers/events/${eventId}/invitations`,
        {
          speakerId,
          invitationMessage,
        }
      );

      toast.success(t("joinRequest.success"));
    } catch (error) {
      console.error(t("joinRequest.errorLog"), error);

      console.log("Response Data:", error.response?.data);

      const responseData = error.response?.data;

      const messageFromAPI =
        responseData?.detail || responseData?.title || responseData?.message;

      if (responseData?.errors) {
        const allFieldErrors = Object.values(responseData.errors)
          .flat()
          .join(" - ");
        toast.error(allFieldErrors);
        return;
      }

      if (messageFromAPI) {
        toast.error(messageFromAPI);
        return;
      }

      // رسالة عامة لو ما لقينا رسالة من API
      toast.error(t("joinRequest.eventEnded"));
    }
  };

  const formatDate = (date) => {
    return moment(date).format("dddd، D MMMM YYYY - hh:mm A");
  };

  return (
    <div dir={languageDirection}>
      <section
        className="bg-light position-relative overflow-hidden"
        style={{ "--bs-bg-opacity": 0.8 }}
      >
        {/* الزخارف - أعلى اليسار */}
        <div
          className="position-absolute top-0 start-0 d-none d-lg-block"
          style={{ opacity: 0.07 }}
        >
          <svg width="180" height="180" viewBox="0 0 200 200">
            <path
              d="M45,0 L0,45 L45,90 L90,45 Z"
              fill="#6B72E0"
              transform="translate(0, 0)"
            />
            <path
              d="M45,0 L0,45 L45,90 L90,45 Z"
              fill="#6B72E0"
              transform="translate(80, 80)"
            />
          </svg>
        </div>

        {/* الزخارف - أسفل اليمين */}
        <div
          className="position-absolute bottom-0 end-0 d-none d-lg-block"
          style={{ opacity: 0.07 }}
        >
          <svg width="150" height="150" viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="50" fill="#6B72E0" />
            <circle cx="50" cy="50" r="35" fill="#ffffff" />
            <circle cx="50" cy="50" r="20" fill="#6B72E0" />
          </svg>
        </div>

        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center" data-aos="fade-up">
              <div
                className="d-inline-flex justify-content-center align-items-center bg-primary-custom rounded-circle mb-3"
                style={{ width: "60px", height: "60px" }}
              >
                <i className="fas fa-calendar-alt fa-lg text-white"></i>
              </div>
              <h1 className="fw-bold text-primary-custom mb-3">
                {t("event_title")}
              </h1>
              <p className="lead mb-4">{t("events_description")}</p>

              {error && <p className="text-danger">{error}</p>}

              <div className="row g-4 justify-content-center mt-2">
                <div className="col-md-4 col-sm-4" data-aos="zoom-in">
                  <div className="card shadow-sm border-0 h-100">
                    <div className="card-body text-center py-4">
                      <h2 className="fw-bold text-primary-custom mb-0">+3</h2>
                      <p className="text-muted mb-0">{t("events_per_year")}</p>
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-4 col-sm-4"
                  data-aos="zoom-in"
                  data-aos-delay="100"
                >
                  <div className="card shadow-sm border-0 h-100">
                    <div className="card-body text-center py-4">
                      <h2 className="fw-bold text-primary-custom mb-0">+7</h2>
                      <p className="text-muted mb-0">{t("arab_countries")}</p>
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-4 col-sm-4"
                  data-aos="zoom-in"
                  data-aos-delay="200"
                >
                  <div className="card shadow-sm border-0 h-100">
                    <div className="card-body text-center py-4">
                      <h2 className="fw-bold text-primary-custom mb-0">+80</h2>
                      <p className="text-muted mb-0">{t("participants")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div id="events-section" className="py-5">
        <div className="container py-4">
          <div className="card shadow-sm mb-5">
            <div className="card-body p-4">
              {/* Events Filter Section  */}
              <div className="row g-3 mb-4 align-items-end">
                <div className="col-md-6">
                  <label className="form-label fw-medium">
                    {t("events_type_label")}
                  </label>
                  <div className="d-flex flex-wrap gap-2">
                    {["all", "upcoming", "past", "online", "in-person"].map(
                      (filterKey) => (
                        <button
                          key={filterKey}
                          className={`btn btn-sm ${
                            activeFilter === filterKey
                              ? "btn-primary"
                              : "btn-outline-primary"
                          }`}
                          onClick={() => handleFilterClick(filterKey)}
                        >
                          {t(`events_filter_${filterKey}`)}
                        </button>
                      )
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="input-group">
                    <span className="input-group-text bg-white border-end-0">
                      <i className="fas fa-search text-muted"></i>
                    </span>
                    <input
                      type="text"
                      className="form-control border-start-0 search-input"
                      placeholder={t("events_search_placeholder")}
                      aria-label={t("events_search_aria")}
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>

                  {/* زر إنشاء فعالية */}
                  <div className="text-end mt-3">
                    <button
                      className="btn btn-primary w-50"
                      onClick={() => {
                        if (!isLoggedIn) {
                          navigate("/login");
                          window.scrollTo(0, 0);
                          return;
                        }

                        if (userRole === 4) {
                          navigate("/organizer-events");
                          window.scrollTo(0, 0);
                          return;
                        }

                        if (userRole === 3) {
                          toast.error(t("unauthorized_speaker"));
                          setTimeout(() => {
                            navigate("/contact");
                            window.scrollTo(0, 0);
                          }, 2000);
                          return;
                        }

                        toast.error(t("unauthorized_account"));
                      }}
                    >
                      <i className="fas fa-plus me-2"></i>{" "}
                      {t("create_new_event")}
                    </button>
                  </div>
                </div>
              </div>

              {/* المحتوى */}
              <div className="row g-4">
                {filteredEvents.map((event) => {
                  const eventDate = new Date(event.eventOn);
                  const day = eventDate.getUTCDate();
                  const month = eventDate.toLocaleString(
                    i18n.language || "ar",
                    { month: "long" }
                  );

                  const location = event.isOnline
                    ? t("events_online")
                    : event.city?.arabicName || t("events_no_location");

                  return (
                    <div key={event.id} className="col-lg-4 col-md-6">
                      <div className="card event-card shadow-sm h-100">
                        <div className="position-relative">
                          <img
                            src={event.bannerUrl}
                            alt={event.name}
                            className="card-img-top"
                            style={{ height: "200px", objectFit: "cover" }}
                          />
                          <div className="position-absolute top-0 end-0 m-3">
                            <div className="event-date">
                              <small>{month}</small>
                              <strong>{day}</strong>
                            </div>
                          </div>
                        </div>
                        <div className="card-body">
                          <h5 className="card-title fw-bold">{event.name}</h5>
                          <p className="card-text text-muted">
                            <i
                              className={`fas ${
                                event.isOnline
                                  ? "fa-video"
                                  : "fa-map-marker-alt"
                              } me-2`}
                            ></i>
                            {location}
                          </p>
                          <div className="d-flex align-items-center mt-3">
                            <img
                              src={
                                event.organizer?.profileImage ||
                                "/assets-v2/images/default-user.png"
                              }
                              className="rounded-circle me-2"
                              alt={event.organizer?.arabicFullName || ""}
                              width={40}
                              height={40}
                            />
                            <div>
                              <small className="text-muted">
                                {t("events_main_speaker")}
                              </small>
                              <p className="mb-0 small fw-medium">
                                {event.organizer?.arabicFullName}
                              </p>
                            </div>
                          </div>
                        </div>
                        {/* الازرار */}
                        <div className="card-footer bg-transparent border-0 pb-3 d-flex gap-2 flex-column">
                          <Link
                            to={`/event-detail/${event.id}`}
                            className="btn btn-sm btn-outline-primary w-100"
                          >
                            {t("events_details")}
                          </Link>
                          <button
                            className="btn btn-sm btn-outline-dark w-100"
                            onClick={() => handleJoinRequest(event.id)}
                          >
                            <i className="fas fa-paper-plane me-1"></i>
                            {t("joinAsSpeaker")}
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Events;
